import type { SVGProps } from 'react';
const DawnFlagST = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-ST_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-ST_svg__a)">
      <path fill="#2ACB41" d="M0 16h22v-5.333H0zM0 5.333h22V0H0z" />
      <path fill="#FDD043" d="M0 10.667h22V5.333H0z" />
      <path fill="#E71E43" d="m0 0 8.38 8L0 16z" />
      <path
        fill="#262626"
        d="m11.524 8.875-1.232.85.415-1.455-1.176-.93 1.488-.048.505-1.425.505 1.425 1.488.049-1.176.93.415 1.455zM16.762 8.875l-1.231.85.414-1.455-1.175-.93 1.487-.048.505-1.425.505 1.425 1.488.049-1.176.93.415 1.455z"
      />
    </g>
  </svg>
);
export default DawnFlagST;
